import {SET_SETTINGS} from '../reducers/settings';

export function setSettings(settings) {
  return {
    type: SET_SETTINGS,
    settings,
  };
}
